export default {
  id: (state) => state.id,
  formData: (state) => state.formData,
  isLoading: (state) => state.loading,
  isActionLoading: (state) => state.actionLoading,
  sort: (state) => state.sort,
  items: (state) => state.items,
  loading: (state) => state.loading,
  search: (state) => state.search,

  detailSearch: (state) => state.detailSearch,
  detailLoading: (state) => state.detailLoading,
  detailFormData: (state) => state.detailFormData,
  detailItems: (state) => state.detailItems,
  detailPage: (state) => state.detailPage,
  detailTotal: (state) => state.detailTotal,
  detailLimit: (state) => state.detailLimit,
  filters: (state) => state.filters,
}
